import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const VisitHistory = ({ visits, clearHistory }) => {
    return (
        <div className="accordion bg-none" id="visit-history-accordion">
            <div className="card bg-none border-0">
                <div
                    className="card-header border-0"
                    id="visit-history-heading"
                >
                    <h2 className="mb-0">
                        <button
                            tabIndex="-1"
                            className="btn border-0 btn-block text-left"
                            type="button"
                            data-toggle="collapse"
                            data-target="#visit-history-collapse"
                            aria-expanded="true"
                            aria-controls="visit-history-collapse"
                        >
                            Recent Visits
                        </button>
                    </h2>
                </div>

                <div
                    id="visit-history-collapse"
                    className="collapse"
                    aria-labelledby="visit-history-heading"
                    data-parent="#visit-history-accordion"
                >
                    <div className="card-body">
                        <ul className="list-group">
                            {[...visits].reverse().map(visit => {
                                const { code, component, url, name } = visit;

                                return (
                                    <li key={code} className="list-group-item">
                                        <Link
                                            style={{ textTransform: "capitalize" }}
                                            to={url}
                                        >
                                            {component}
                                            {` ${code ? code : "List"}`}
                                        </Link>
                                        <small className="text-dark">
                                            {name ? name : ""}{" "}
                                        </small>
                                    </li>
                                );
                            })}
                            <li className="list-group-item">
                                <button
                                    tabIndex="-1"
                                    onClick={clearHistory}
                                    className="btn btn-sm btn-secondary btn-block"
                                >
                                    Clear
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

VisitHistory.propTypes = {
    visits: PropTypes.array,
    clearHistory: PropTypes.func
};

export default VisitHistory;
